// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';

//Third Party
import moment from 'moment';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CPDFormatters
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class CPDFormatters {

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(){};

    //==================================
    // formatDateString
    //==================================
    // This is the standard date formatter we use throughout CPD.  It returns a STRING.
    // defaultValue<str>:       //This is the value returned if the dateString cannot be parsed
    formatDateString(dateString, defaultValue){

        defaultValue = defaultValue || "";
        if (!dateString){ return defaultValue; }

        let date = moment(dateString);
        return date.isValid() ? date.format("M/D/YYYY") : defaultDateString;
    };

    //==================================
    // formatJSDate
    //==================================
    // This is a very simple, "no frills" formatter that uses only javascript
    formatJSDate(jsDate){
        
        return (jsDate.getMonth() + 1) + "/" + jsDate.getDate() + "/" + jsDate.getFullYear();
    };

    //==================================
    // dateStringToDate
    //==================================
    // This is the standard date formatter we use throughout CPD.  It returns a javascript DATE object.
    // defaultValue<str>:       //This is the value returned if the dateString cannot be parsed
    dateStringToDate(dateString, defaultDate){
        
        defaultDate = defaultDate || null;
        if (!dateString){ return defaultDate; }

        let m = moment(dateString);

        //Jump out if we can't parse the date 
        if (!m.isValid()){
            return defaultDate;
        }

        return m.toDate();
    };

    //==================================
    // formatError
    //==================================
    // Tries to handle all error responses coming from the server.  Unfortunately the responses are not
    // as well homogenized as they could be.
    formatError(err){

        let msg = "An unexpected error has occurred";
        
        //Skip if no error is provided
        if (err){

            //First check to see if this is a response object with a message directly on it
            if (err.ErrorMessage){
                msg = err.ErrorMessage;
                return msg;
            }

            //Check for an error object
            if (err.error && err.error.message){
                
                msg = err.error.message;

                //Check for model errors
                //(this is the older approach were everything is REST against a model.  Quite a bit of this is still in place).
                if (err.error.code == 412){
                    
                    //Add specific model error details to the output
                    msg += "<ul>";
                    for (let i=0; i<err.error.details.length; i++){
                        
                        let detail = err.error.details[i];
                        msg += "<li style='list-style-type:circle; margin-left:20px;'>" + detail.field + "</li>";

                        //Grab the specific errors for this field 
                        msg += "<li style='list-style-type:none; margin-left:0;'><ul>";
                        for (let j=0; j<detail.errors.length; j++){
                            msg += "<li style='list-style-type:circle; margin-left:30px;'>" + detail.errors[j] + "</li>";
                        }
                        msg += "</ul></li>";
                    }
                    msg += "</ul>";
                }

                return msg;
            }

            //If there was no error object, but there is a root message, use that
            if (err.message){ return err.message; }

            //If we get here, then most likely we are looking at a custom error message from the server,
            //so let's just spit it out as is.
            msg = err;
        }
        
        return msg;
    };

    //==================================
    // formatValidationErrors
    //==================================
    formatValidationErrors(errList){

        if (errList.length == 0){ return ""; }
        
        var msg = "<ul>";
        for (let i=0; i<errList.length; i++){
            msg += "<li style='list-style-type:circle; margin-left:20px;'>" + errList[i] + "</li>";
        }
        msg += "</ul>";

        return msg;
    };

}
